<template>
	<Transition name="list">
		<div style="margin-right: 2px;" v-if="showMenu">
			<el-menu :default-active="menusStore.currentLevel2MenuKey" style="border: unset;background-color: unset;"
				@select="MenuSelect">
				<el-menu-item :index="item.path" v-for="(item, index) in menus"
					style="border-radius: 5px;margin: 0 5px;margin-top: 5px;height: 44px;">
					<el-icon class="icon_view" size="17" v-if="layoutStore.showLevel2MenuIcon">
						<component :is="item.icon"></component>
					</el-icon>
					<span>{{ item.label }}</span>
				</el-menu-item>
			</el-menu>
		</div>
	</Transition>
</template>

<script>
import { useRouter } from 'vue-router'
import { useLayoutStore } from "../../../../stores/layout"
import { useMenusStore } from "../../../../stores/menus"

export default {
	setup() {
		const router = useRouter()
		const layoutStore = useLayoutStore()
		const menusStore = useMenusStore()

		return {
			router,
			layoutStore,
			menusStore
		}
	},
	computed: {
		menus() {
			for (let i = 0; i < this.menusStore.navigationMenusList.length; i++) {
				let item = this.menusStore.navigationMenusList[i]
				if (item.path == this.menusStore.currentLevel1MenuKey) {
					return item.children
				}
			}
		},

		showMenu() {
			return this.menus && this.menus.length > 0
		},


	},
	methods: {
		MenuSelect(index, indexPath, item, routeResult) {
			this.router.push(index)
		},
	}
}
</script>

<style scoped lang="less">
/* 对移动中的元素应用的过渡 */
.list-enter-active,
.list-leave-active {
	transition: all 0.2s ease;
}

.list-enter-from,
.list-leave-to {
	opacity: 0;
	transform: translateX(-10px);
}

.el-menu .is-active {
	transition: all 0.0s ease;
	background-color: rgba(64, 158, 255, .1);
	color: #409eff !important;
	font-weight: 600 !important;
}
</style>